import type { CalendarDensityBand } from '#layers/listing/constants/calendar';
import { CALENDAR_DENSITY_BANDS } from '#layers/listing/constants/calendar';

export interface DensityLevel {
	minCount: number;
	fillClass: CalendarDensityBand['fillClass'];
}

/** Drops a band whose threshold repeats the previous band's, so each level starts at a higher count. */
export function getDensityLevels(counts: Iterable<number>): DensityLevel[] {
	const busy = [...counts].filter((count) => count > 0).toSorted((a, b) => a - b);
	if (busy.length === 0) return [];

	const thresholds = CALENDAR_DENSITY_BANDS.map(({ percentile }) => percentile === null ? 1 : busy[Math.floor(percentile * busy.length)]!);

	return CALENDAR_DENSITY_BANDS.flatMap(({ fillClass }, band) => {
		const minCount = thresholds[band]!;
		return band === 0 || minCount > thresholds[band - 1]! ? [{ minCount, fillClass }] : [];
	});
}

export function getDensityLevel(levels: readonly DensityLevel[], count: number): DensityLevel | undefined {
	return levels.findLast((level) => count >= level.minCount);
}
